var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47.01,
    y: 55.87,
    width: 5.97,
    height: 15.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.75,41V31.56a17.75,17.75,0,0,0-35.5,0V41H20V81.4A4.62,4.62,0,0,0,24.65,86h50.7A4.62,4.62,0,0,0,80,81.4V41Zm7.6,40.38H24.65V45.62h50.7ZM62.51,41h-25V31.56a12.51,12.51,0,0,1,25,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/LockClosed.c6e0a7577d609a1b3db80d17b5324fb0.svg";
export { ForwardRef as ReactComponent };